module.exports = __webpack_public_path__ + "assets/img/u5e6dd2d3f1a10.970638f9.png";